import type { ComponentType, MouseEventHandler, ReactNode } from 'react';
import { ListItem, ListItemButton } from '@mui/material';
import type { IconProps } from '../icons/createIcon';
import { MyNavLink } from './MyNavLink.tsx';

export interface DesktopMenuItemProps {
    label: ReactNode;
    iconComponent: ComponentType<IconProps>;
    cta?: boolean;
    to: string;
    exact?: boolean;
    onClick?: MouseEventHandler;
}

const DesktopMenuItem = ({
    label,
    iconComponent: Icon,
    cta = false,
    to,
    exact = false,
    onClick,
}: DesktopMenuItemProps) => {
    return (
        <ListItem disablePadding>
            <ListItemButton
                component={MyNavLink}
                end={exact}
                to={to}
                onClick={onClick}
                sx={(theme) => ({
                    borderBottom: `solid 1px ${theme.bino.color.boxShadowBorder}`,
                    display: 'block',
                    color: cta ? theme.bino.color.white : theme.bino.labelColor,
                    backgroundColor: cta
                        ? theme.palette.mode === 'dark'
                            ? theme.bino.color.darkGray
                            : theme.bino.color.grayishBlue
                        : null,
                    //backgroundColor: cta ? theme.bino.color.primary : null,
                    '&:hover': {
                        color: cta ? null : theme.palette.primary.main,
                        backgroundColor: cta
                            ? theme.palette.primary.main
                            : null,
                    },
                    padding: 0,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    '& > svg': {
                        px: '20px',
                        py: cta ? '32px' : '32px', // 32 / 16
                        display: 'inline-block',
                        verticalAlign: 'middle',
                    },
                    '& > label': {
                        cursor: 'pointer',
                        display: 'inline',
                        fontSize: '12px',
                        margin: '16px 0',
                        letterSpacing: '1px',
                        fontWeight: 'bold',
                        lineHeight: 1,
                        textDecoration: 'none',
                        textTransform: 'uppercase',
                        color: 'inherit',
                    },
                    '&.active > *': {
                        color: theme.palette.primary.main,
                    },
                })}
            >
                <Icon size={24} />
                <label>{label}</label>
            </ListItemButton>
        </ListItem>
    );
};

export default DesktopMenuItem;
